import { useEffect } from 'react';
// import ContactUs from '../components/forms/ContactUs';
// import { ContactFormProvider } from '../contexts/ContectFormProvider';
import solar_panels from "../components/assets/panels-electricity-order-sunlight.webp";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Cta from '../components/Cta';
import Seo from '../components/Seo';
const AboutUsPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false
    });
  }, []);

  const values = [
    { 
      title: "Sustainability", 
      desc: "We prioritize eco-friendly practices in every project we undertake.",
      // icon: "🌱"
    },
    { 
      title: "Innovation", 
      desc: "We adopt the latest solar technologies to maximize efficiency and reliability.",
      // icon: "⚡"
    },
    { 
      title: "Customer First", 
      desc: "We provide personalized services that meet your specific energy needs.",
      // icon: "💝"
    },
  ];

  return (
    <>
      <Seo
        title="About KK Solar | Solar Company in Kutch, Gujarat"
        description="Learn about Boost Solar's mission, experience, and customer-first solar solutions for homes, businesses, and industry in Kutch."
        url="https://kksolar.co.in/about"
      />
      <div className="max-w-8xl mt-24 mx-auto overflow-hidden">

      {/* Hero Section */}
      <section className="relative min-h-[60vh] bg-gradient-to-br from-primary via-secondary to-blue-900 flex items-center justify-center overflow-hidden">
        {/* Animated Background */}
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-opprimary/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-40 h-40 bg-white/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        </div>
        
        <div 
          className="relative text-center max-w-4xl px-6 space-y-6"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div 
            className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full border border-white/20"
            data-aos="fade-down"
            data-aos-delay="400"
          >
            <span className="w-3 h-3 bg-opprimary rounded-full mr-3 animate-pulse"></span>
            <span className="text-white font-semibold text-lg">About Our Journey</span>
          </div>
          
          <h1 
            className="text-5xl lg:text-6xl font-bold text-white leading-tight"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            About <span className="text-opprimary">Boost Solar</span>
          </h1>
          
          <p 
            className="text-xl opacity-90 max-w-3xl mx-auto leading-relaxed text-white"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            Powering a sustainable future with reliable and affordable solar energy solutions.
          </p>
        </div>

     
      </section>

      {/* About Us Content */}
      <section className="max-w-8xl mx-auto px-6 py-20 bg-background relative overflow-hidden">
        {/* Background Animation */}
        <div className="absolute inset-0 bg-gradient-to-br from-opprimary/5 to-primary/5 animate-gradient-x"></div>
        
        <div 
          className="grid md:grid-cols-2 gap-12 items-center relative z-10"
          data-aos="fade-up"
        >
          <div 
            className="relative group"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <div className="rounded-2xl overflow-hidden shadow-lg transform group-hover:shadow-2xl transition-all duration-500">
              <img
                src={solar_panels}
                alt="About Boost Solar"
                className="w-full h-[400px] object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
            
            {/* Floating Element */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl p-4 shadow-2xl border border-gray-100 transform rotate-3">
              <div className="text-2xl text-opprimary mb-1">🏆</div>
              <div className="text-primary font-bold text-sm">Trusted</div>
              {/* <div className="text-gray-600 text-xs">Since 2015</div> */}
            </div>
          </div>
          
          <div 
            className="space-y-6"
            data-aos="fade-left"
            data-aos-delay="400"
          >
            <div className="inline-flex items-center px-4 py-2 bg-opprimary/10 rounded-full border border-opprimary/20">
              <span className="text-opprimary font-semibold text-sm">Our Story</span>
            </div>
            
            <h2 className="text-4xl font-bold text-primary">Who We Are</h2>
            
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                At Boost Solar, we are committed to providing cutting-edge solar technology
                that empowers homes and businesses to harness the power of the sun.
                With years of expertise, our team ensures seamless installation, top-quality
                products, and unmatched customer support.
              </p>
              <p>
                Our mission is to accelerate the transition to clean, renewable energy for
                everyone — making solar energy accessible, affordable, and efficient.
              </p>
              <p>
                Whether you're a homeowner, business owner, or community organization,
                we provide tailor-made solar solutions that deliver long-term savings
                and environmental benefits.
              </p>
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 pt-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-opprimary">500+</div>
                <div className="text-gray-600 text-sm">Projects</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-opprimary">2 MW</div>
                <div className="text-gray-600 text-sm">Capacity</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-opprimary">98%</div>
                <div className="text-gray-600 text-sm">Satisfaction</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-20 bg-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
        
        <div className="max-w-7xl mx-auto px-6 text-center relative z-10">
          <div 
            className="mb-12"
            data-aos="fade-up"
          >
            <div className="inline-flex items-center px-4 py-2 bg-opprimary/10 rounded-full border border-opprimary/20 mb-6">
              <span className="text-opprimary font-semibold text-sm">Our Values</span>
            </div>
            <h2 className="text-4xl font-bold text-primary mb-4">Our Core Values</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              The principles that guide everything we do at Boost Solar
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div 
                key={index}
                data-aos="flip-up"
                data-aos-delay={index * 200}
                className="group"
              >
                <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-4 transition-all duration-500 p-8 border border-gray-100 relative overflow-hidden">
                  {/* Background Decor */}
                  <div className="absolute top-0 right-0 w-20 h-20 bg-opprimary/5 rounded-full -translate-y-10 translate-x-10"></div>
                  
                  {/* Icon */}
                  <div className="text-5xl mb-6 transform group-hover:scale-110 group-hover:rotate-12 transition-transform duration-300">
                    {value.icon}
                  </div>
                  
                  <h3 className="text-xl font-bold text-primary mb-4 group-hover:text-secondary transition-colors duration-300">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">{value.desc}</p>
                  
                  {/* Hover Effect */}
                  <div className="absolute inset-0 bg-gradient-to-br from-opprimary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Us Form Section */}
      {/* <section className="bg-background py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-opprimary/5 animate-gradient-xy"></div>
        
        <div className="max-w-6xl mx-auto px-6 relative z-10">
          <div 
            className="text-center mb-2"
            data-aos="fade-up"
          >
            <div className="inline-flex items-center px-4 py-2 bg-opprimary/10 rounded-full border border-opprimary/20 mb-6">
              <span className="text-opprimary font-semibold text-sm">Get In Touch</span>
            </div>
            <h2 className="text-4xl font-bold text-primary mb-4">
              Get In Touch With Us
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Have questions about going solar or need a custom solution?  
              Fill out the form below and our team will get back to you promptly.
            </p>
          </div>
          
          <div 
            className="bg-white rounded-2xl shadow-2xl p-8 border-t-4 transform hover:shadow-3xl transition-all duration-500"
            style={{ borderColor: '#ff8e03ff' }}
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <ContactFormProvider>
              <ContactUs />
            </ContactFormProvider>
          </div>
        </div>

    
      </section> */}

      <Cta/>
      <style jsx>{`
        .bg-grid-pattern {
          background-image: linear-gradient(rgba(2, 26, 92, 0.1) 1px, transparent 1px),
                            linear-gradient(90deg, rgba(2, 26, 92, 0.1) 1px, transparent 1px);
          background-size: 50px 50px;
        }
        
        @keyframes gradient-x {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        
        @keyframes gradient-xy {
          0%, 100% { background-position: 0% 0%; }
          50% { background-position: 100% 100%; }
        }
        
        .animate-gradient-x {
          animation: gradient-x 15s ease infinite;
          background-size: 400% 400%;
        }
        
        .animate-gradient-xy {
          animation: gradient-xy 15s ease infinite;
          background-size: 400% 400%;
        }
      `}</style>
    </div>
    </>
  );
};

export default AboutUsPage;